import { Injectable } from '@angular/core';
import { CustomAjax } from '../AjaxHelper';
import { ServiceProvider } from '../AllTableClasses';

@Injectable({
  providedIn: 'root'
})
export class ServiceProviderService {
  constructor(private ajax: CustomAjax) { }

  public SPTypeGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/ServiceProvider/SPTypeGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public SPTypeServiceProviderGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/ServiceProvider/SPTypeServiceProviderGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public ServiceProviderGetByGuid(guid: string, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/ServiceProvider/ServiceProviderGetByGuid", `guid=${guid}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public ServiceProviderSet(service: ServiceProvider, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/ServiceProvider/ServiceProviderSet", service,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public ServiceProviderGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/ServiceProvider/ServiceProviderGet", '',
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  public AdministrationServiceProviderGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/ServiceProvider/AdministrationServiceProviderGet", '',
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public LeaveServiceProviderGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/ServiceProvider/LeaveServiceProviderGet", '',
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
}
